import { gql } from "apollo-boost";

export const GET_PRODUCTS = gql`
  query Products(
    $limit: Int
    $skip: Int
    $orderBy: OrderByInput
    $where: ProductWhereInput
  ) {
    products(limit: $limit, skip: $skip, orderBy: $orderBy, where: $where) {
      data {
        image
        id
        name
        size
        detail
        barCode
        id
        size
        unit
        amount
        cfMessage
        originAmount
        originPrice
        note
        price
        currency
        priceUsd
        priceThb
        star
        sort
        priceLak
        creationDate
        expirationDate
        priceOptions {
          contain
          price
          unit
        }
        unitId {
          name
          id
        }
        brand {
          name
          id
        }
        brandName
        category {
          name
          id
        }
        categoryName
        subbrand {
          id
          name
        }
        subBrandName
        createdAt
        dimension{
          length
          width
          height
          weight
        }
        survivalId {
          id
          survivalNumber
          note
          isDeleted
        }
        shippingCost
      }
      total
    }
  }
`;

export const HIDE_PRODUCT_OUT_OF_STOCK = gql`
query HideProductsOutOfStock($orderBy: OrderByInput, $skip: Int, $limit: Int, $where: ProductWhereInput) {
  hideProductsOutOfStock(orderBy: $orderBy, skip: $skip, limit: $limit, where: $where) {
    data {
        image
        id
        name
        size
        detail
        barCode
        id
        size
        unit
        amount
        cfMessage
        originAmount
        originPrice
        note
        price
        currency
        priceUsd
        priceThb
        star
        sort
        priceLak
        creationDate
        expirationDate
        priceOptions {
          contain
          price
          unit
        }
        unitId {
          name
          id
        }
        brand {
          name
          id
        }
        brandName
        category {
          name
          id
        }
        categoryName
        subbrand {
          id
          name
        }
        subBrandName
        createdAt
        dimension{
          length
          width
          height
          weight
        }
        survivalId {
          id
          survivalNumber
          note
          isDeleted
        }
        shippingCost
      }
      total
  }
}
`

export const ELASTICSEARCH_PRODUCT = gql`
query Data($limit: Int, $where: ProductWhereInput) {
  getProductElastisSearch(limit: $limit, where: $where) {
    data {
      id
      name
      amount
      price
      survivalId {
        id
        survivalNumber
      }
    }
  }
}
`;
export const GET_EXCHANGE_RATE = gql`
  query ExchangeRate($where: ExchangeRateWhereInput) {
    exchangeRate(where: $where) {
      baht
      id
      kip
      usd
      shop {
        id
        name
      }
    }
  }
`;

export const GET_PRODUCT_GENBARCODE = gql`
  query Products($where: ProductWhereInput) {
    products(where: $where) {
      total
    }
  }
`;

export const GET_PRODUCT_HISTORY = gql`
  query ProductHistories(
    $where: ProductHistoryWhereInput
    $orderBy: OrderByInput
    $skip: Int
    $limit: Int
  ) {
    productHistories(
      where: $where
      orderBy: $orderBy
      skip: $skip
      limit: $limit
    ) {
      total
      data {
        name
        updatedAt
        amount
        currency
        barCode
        unit {
          id
          name
        }
        category {
          name
          id
        }
        brand {
          name
          id
        }
      }
    }
  }
`;

export const SCAN_PRODUCT = gql`
  query StocksByBarcode($where: ScanBarcodeInput!) {
    stocksByBarcode(where: $where) {
      image
      name
      size
      detail
      barCode
      id
      size
      unit
      amount
      originAmount
      originPrice
      note
      price
      currency
      priceUsd
      priceThb
      star
      priceLak
      priceOptions {
        contain
        price
        unit
      }
      unitId {
        name
        id
      }
      brand {
        name
        id
      }
      brandName
      category {
        name
        id
      }
      categoryName
      subbrand {
        id
        name
      }
      subBrandName
      createdAt
    }
  }
`;

export const STOCK_ALMOST_GONES = gql`
  query StockAlmostGones($skip: Int, $limit: Int, $where: StockShopWhereInput) {
    stockAlmostGones(skip: $skip, limit: $limit, where: $where) {
      total
      data {
        name
        amount
        barCode
        _id
      }
    }
  }
`;

export const GET_PRODUCT_EXPIRE = gql`
  query Query($expireKey: String) {
    getProductExpire(expireKey: $expireKey)
  }
`;
